import { graphql } from 'gatsby';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import * as React from 'react';
import styled from 'styled-components';

type ThumbnailImgStyle = 'upper-half-circle' | 'lower-half-circle' | 'full-circle' | undefined;

function getBorder(thumbStyle: ThumbnailImgStyle | null): string {
  let borderRadius = 'clamp(5px, 6%, 10px)';
  switch (thumbStyle) {
    case 'upper-half-circle':
      borderRadius = '50% 50% 0 0';
      break;

    case 'lower-half-circle':
      borderRadius = '0 0 50% 50%';
      break;

    case 'full-circle':
      borderRadius = '50%';
      break;

    default:
      break;
  }
  return borderRadius;
}

interface ImgWrapperProps {
  'data-thumb-style': ThumbnailImgStyle | null;
}

const StyledImage = styled(GatsbyImage)<ImgWrapperProps>`
  border-radius: ${(props) => getBorder(props['data-thumb-style'])};
  overflow: hidden;
  isolation: isolate; /* fixes overflow hidden issue with border-radius on Safari */

  img {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    object-position: center;
  }
`;

interface Props {
  imageData: ImageDataLike | null;
  alt: string | null;
  thumbStyle?: string | null;
}

export default function PostImage({ imageData, alt, thumbStyle = null }: Props) {
  const image = imageData ? getImage(imageData) : null;
  return image ? (
    <StyledImage data-thumb-style={thumbStyle as ThumbnailImgStyle} image={image} alt={alt || ''} />
  ) : null;
}

export const PostImageDataFragment = graphql`
  fragment PostImageData on WpNodeWithFeaturedImageToMediaItemConnectionEdgeType {
    node {
      localFile {
        childImageSharp {
          gatsbyImageData(placeholder: DOMINANT_COLOR, width: 500)
        }
      }
    }
  }
`;
